@import '../../scss/mixin';

.root {
  --s: 1;
  --u: 1vw;
  --rem: 16px;

  pointer-events: none;
  position: fixed;
  bottom: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 100%;

  z-index: 10000;

  :global(.llm__container) {
    padding: 0 clampUnit(20, 110);
  }
}
